<script setup lang="ts">
const route = useRoute();
const { data: dinosaur } = await useFetch(`/api/dinosaurs/${route.params.name}`);
</script>

<template>
	<main v-if="dinosaur">
		<h1 class="text-2xl font-bold mb-4">{{ dinosaur.name }}</h1>
		<p class="mb-4">{{ dinosaur.description }}</p>
		<NuxtLink to="/" class="text-blue-600 hover:text-blue-800 hover:underline"> Back to all dinosaurs </NuxtLink>
	</main>
</template>
